import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_212: DocMigration = {
  maxSchemaVersion: "0.0.212",
  description: "Set window arch boolean default to subtract",
  apply(json: any) {
    //setting default window shape for window descriptors
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];

      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const windowTypeId in setting.windowTypes) {
          const windowType = setting.windowTypes[windowTypeId];
          windowType.archBoolean = "SUBTRACT";
        }
      }
    }

    return json;
  },
};

export default migration_0_0_212;
